import { useSelector } from "react-redux"

import ReferralsAdminPage from "./ReferralsAdminPage"
import ReferralsUserPage from "./ReferralsUserPage"

const Referrals = () => {
  const { isAdmin } = useSelector((state) => state.auth)

  if (isAdmin) return <ReferralsAdminPage />
  else return <ReferralsUserPage />
}

export default Referrals
